import React from "react";

import style from "./style.module.css";

export default function Editor({text}) {
    return (
        <div className={style.cEditor} dangerouslySetInnerHTML={{ __html: text }} />
    )
}